import { useEffect, useState } from "react";
import { getHomepage } from "utils";
import * as Scrivito from "scrivito";

export const useWizardData = (subType: string) => {
  const [wizardSubTypeObj, setWizardSubTypeObj] = useState<Scrivito.Obj>();
  const [configWizardObjRefs, setConfigWizardObjRefs] =
    useState<Scrivito.Obj[]>();
  const [wizardItemsObjArrRefs, setWizardItemsObjArrRefs] =
    useState<Scrivito.Obj[]>();
  const [wizardItemStepsTitles, setWizardItemStepsTitles] =
    useState<string[]>();
  const [wizardItemTitle, setWizardItemTitle] = useState<string>();

  useEffect(() => {
    const handleGetWizardBySubType = async () => {
      const result = await Scrivito.load(() => {
        const configWizardObjRefs_ = getHomepage()?.get("configWizardObjRefs");
        const wizardListObjRef = (configWizardObjRefs_ as Scrivito.Obj[])?.[0];

        const wizardItemsObjArrRefs_ = wizardListObjRef.get("wizardItem") || [];
        const wizardSubTypeObj_ = (
          wizardItemsObjArrRefs_ as Scrivito.Obj[]
        ).find((wizard) => wizard.get("subType") === subType);
        const wizardItemStepsTitles_ = wizardSubTypeObj_?.get("menuStepTitles");
        const wizardItemTitle_ = wizardSubTypeObj_?.get("menuTitle");
        return {
          configWizardObjRefs_,
          wizardItemsObjArrRefs_,
          wizardSubTypeObj_,
          wizardItemStepsTitles_,
          wizardItemTitle_,
        };
      });

      setConfigWizardObjRefs(result.configWizardObjRefs_ as Scrivito.Obj[]);
      setWizardItemsObjArrRefs(result.wizardItemsObjArrRefs_ as Scrivito.Obj[]);
      setWizardSubTypeObj(result.wizardSubTypeObj_);
      setWizardItemStepsTitles(result.wizardItemStepsTitles_ as string[]);
      setWizardItemTitle(result.wizardItemTitle_ as string);
    };

    if (subType) {
      handleGetWizardBySubType();
    }
  }, [subType]);

  return {
    wizardSubTypeObj,
    configWizardObjRefs,
    wizardItemsObjArrRefs,
    wizardItemStepsTitles,
    wizardItemTitle,
  };
};
